import { apiFetch } from './client.js';

/** Texto de ayuda contextual de un campo (spec 2026-07-02, tabla context_help_texts). */
export interface ContextHelpText {
  key: string;
  title: string;
  queEs: string;
  comoLlenarlo: string;
  ejemplo: string;
  afecta: string[];
  seccion: string;
  sortOrder: number;
  updatedAt: string;
  updatedBy: string | null;
}

export async function listContextHelp(): Promise<ContextHelpText[]> {
  const r = await apiFetch<{ texts: ContextHelpText[] }>('/api/v1/context-help');
  return r.texts;
}

export async function updateContextHelp(
  key: string,
  body: Pick<ContextHelpText, 'title' | 'queEs' | 'comoLlenarlo' | 'ejemplo' | 'afecta'>,
): Promise<ContextHelpText> {
  const r = await apiFetch<{ text: ContextHelpText }>(`/api/v1/staff/context-help/${encodeURIComponent(key)}`, {
    method: 'PUT',
    // apiFetch serializa `body` a JSON por sí mismo.
    body: {
      title: body.title,
      que_es: body.queEs,
      como_llenarlo: body.comoLlenarlo,
      ejemplo: body.ejemplo,
      afecta: body.afecta,
    },
  });
  return r.text;
}
